import { render, staticRenderFns } from "./SearchSvg.vue?vue&type=template&id=4897b041&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897b041",
  null
  
)

export default component.exports